"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ACTION_DELETE_ENTITY = void 0;
exports.getLocalActionCreators = getLocalActionCreators;
exports.removeItem = removeItem;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _related = require("./related");

var _entities = require("../../reducers/entities");

var norm = _interopRequireWildcard(require("@rexlabs/entity-normalizer"));

var _invariant = _interopRequireDefault(require("invariant"));

var _lodash = _interopRequireDefault(require("lodash"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ACTION_DELETE_ENTITY = 'entities/DELETE_ENTITY';
/**
 * Returns action creators for local entity manipulations
 * @param  {string} type
 * @param  {Object} config
 * @return {Object}
 */

exports.ACTION_DELETE_ENTITY = ACTION_DELETE_ENTITY;

function getLocalActionCreators(type, config) {
  return {
    // Pushes an item into the redux store
    // Needs to be an async action, as we potentially want to trigger actions
    //  on other entities from here to push related information!
    pushItem: {
      request: function request(payload, model, dispatch) {
        (0, _invariant.default)(payload.data, "You need to define the item data you want to push => 'pushItem({data: {...}})'");
        return new _promise.default(function (resolve) {
          var _context;

          var _norm$processEntityIt = norm.processEntityItem({
            data: payload.data
          }, config.related),
              item = _norm$processEntityIt.item,
              related = _norm$processEntityIt.related,
              relatedData = _norm$processEntityIt.relatedData;

          (0, _forEach.default)(_context = (0, _keys.default)(related)).call(_context, function (key) {
            delete item[key];
          });
          (0, _related.pushRelateds)(dispatch, config.related, relatedData, payload.uuid);
          resolve({
            data: item,
            related: related
          });
        });
      },
      reduce: {
        initial: _lodash.default.identity,
        success: _entities.pushItem
      }
    },
    // Same as bulk action
    pushItems: {
      request: function request(payload, model, dispatch) {
        (0, _invariant.default)(_lodash.default.isArray(payload.items), "You need to define the items you want to push => 'pushItems({items: [{...}]})'");
        return new _promise.default(function (resolve) {
          var _context2;

          payload.related = {};
          (0, _forEach.default)(_context2 = payload.items).call(_context2, function (data, i) {
            var _context3;

            var _norm$processEntityIt2 = norm.processEntityItem({
              data: data
            }, config.related),
                related = _norm$processEntityIt2.related,
                relatedData = _norm$processEntityIt2.relatedData; // NOTE: this is a hack to quick fix store duplication issues!


            (0, _forEach.default)(_context3 = (0, _keys.default)(related)).call(_context3, function (key) {
              delete payload.items[i][key];
            });
            (0, _related.pushRelateds)(dispatch, config.related, relatedData, payload.uuid);
            payload.related[data.id] = related;
          }); // TODO: check if that is correct that we pass down the whole payload..

          resolve(payload);
        });
      },
      reduce: {
        initial: _lodash.default.identity,
        success: _entities.pushItems
      }
    },
    removeItem: {
      actionName: ACTION_DELETE_ENTITY,
      reduce: function reduce(state, action) {
        var _action$payload = action.payload,
            type = _action$payload.type,
            id = _action$payload.id;
        (0, _invariant.default)(id, "You have to define the id of the item you want to remove => 'removeItem({id: ..., type: ...})'");
        (0, _invariant.default)(type, "You have to define the type of the entity you want to remove => 'removeItem({id: ..., type: ...})'");
        return norm.removeRelatedItem(state, type, id);
      }
    },
    // List item meta data handling
    pushListItemMeta: {
      reduce: function reduce(state, action) {
        var _action$payload2 = action.payload,
            listId = _action$payload2.listId,
            itemId = _action$payload2.itemId,
            meta = _action$payload2.meta;
        (0, _invariant.default)(listId, "You need to pass in the ID of the list you want to store meta data on => 'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})'");
        (0, _invariant.default)(itemId, "You need to define the ID of the list item for the meta data => 'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})'");
        (0, _invariant.default)(meta && _lodash.default.isObject(meta), "You need to pass in the meta data as an object => 'pushListItemMeta({listId: ..., itemId: ..., meta: {...}})'");
        return norm.setListItemMeta(state, listId, itemId, meta);
      }
    },
    removeListItemMeta: {
      reduce: function reduce(state, action) {
        var _action$payload3 = action.payload,
            listId = _action$payload3.listId,
            itemId = _action$payload3.itemId,
            meta = _action$payload3.meta,
            metaKey = _action$payload3.metaKey;
        (0, _invariant.default)(listId, "You need to pass in the ID of the list you want to remove meta data from => 'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})'");
        (0, _invariant.default)(itemId, "You need to define the ID of the list item to remove the meta data from => 'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})'");
        (0, _invariant.default)(meta && _lodash.default.isObject(meta), "You need to pass in the meta key you want to remove => 'removeListItemMeta({listId: ..., itemId: ..., metaKey: ...})'");
        return norm.removeListItemMeta(state, listId, itemId, metaKey);
      }
    }
  };
}
/**
 * Generic `removeItem` action
 * @param  {string} type
 * @param  {string} id
 * @return {Object} Redux action
 */


function removeItem(type, id) {
  return {
    type: ACTION_DELETE_ENTITY,
    payload: {
      type: type,
      id: id
    }
  };
}